/**
 * Stable CSS class names for E2E — User sale order status history drawer.
 */
export const USHSD = {
    root: 'order-detail-user-sale-status-history-drawer__root',
    loadingWrap: 'order-detail-user-sale-status-history-drawer__loading-wrap',
    loadingInner: 'order-detail-user-sale-status-history-drawer__loading-inner',
    header: 'order-detail-user-sale-status-history-drawer__header',
    title: 'order-detail-user-sale-status-history-drawer__title',
    closeButton: 'order-detail-user-sale-status-history-drawer-input--button-close',
    closeIcon: 'order-detail-user-sale-status-history-drawer__close-icon',
    table: 'order-detail-user-sale-status-history-drawer__table',
    tableHeadRow: 'order-detail-user-sale-status-history-drawer__head-row',
    headCellDate: 'order-detail-user-sale-status-history-drawer__head-cell-date',
    headCellUser: 'order-detail-user-sale-status-history-drawer__head-cell-user',
    headCellUserType: 'order-detail-user-sale-status-history-drawer__head-cell-user-type',
    headCellStatus: 'order-detail-user-sale-status-history-drawer__head-cell-status',
    bodyRow: 'order-detail-user-sale-status-history-drawer__body-row',
    bodyCellDate: 'order-detail-user-sale-status-history-drawer__body-cell-date',
    bodyCellUser: 'order-detail-user-sale-status-history-drawer__body-cell-user',
    bodyCellUserType: 'order-detail-user-sale-status-history-drawer__body-cell-user-type',
    bodyCellStatus: 'order-detail-user-sale-status-history-drawer__body-cell-status',
    footerRow: 'order-detail-user-sale-status-history-drawer__footer-row',
    emptyWrap: 'order-detail-user-sale-status-history-drawer__empty-wrap',
    emptyIcon: 'order-detail-user-sale-status-history-drawer__empty-icon',
    emptyTitle: 'order-detail-user-sale-status-history-drawer__empty-title',
} as const;

